"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagSlIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagSlIcon = (0, _mobxReact.observer)(_class = (_FlagSlIcon = /*#__PURE__*/function (_React$Component) {
  function FlagSlIcon() {
    _classCallCheck(this, FlagSlIcon);
    return _callSuper(this, FlagSlIcon, arguments);
  }
  _inherits(FlagSlIcon, _React$Component);
  return _createClass(FlagSlIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 100 100",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        id: "slovenian-flag"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#F5F5F5",
        x: "0",
        y: "0",
        width: "100",
        height: "33.3"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#FF5252",
        x: "0",
        y: "66.7",
        width: "100",
        height: "33.3"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#005CE5",
        x: "0",
        y: "33",
        width: "100",
        height: "34"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M51.4,20.6 C51.4,20.6 50.9,37.5 48.5,42.2 C45.6,48 42.6,49.7 38.2,51.3 C33.8,49.7 30.9,48 27.9,42.2 C25.5,37.5 25,20.6 25,20.6 C33.4,16.8 43,16.8 51.4,20.6 Z",
        id: "Path",
        fill: "#005CE5"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group",
        transform: "translate(30.000000, 29.000000)",
        fill: "#F5F5F5"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M12,15 C11.7,14.8 11.4,14.6 10.9,14.6 C10.4,14.6 10.1,14.7 9.8,15 C9.4,15.2 9,15.5 8.1,15.5 C7.3,15.5 6.8,15.2 6.4,15 C6.1,14.8 5.9,14.6 5.3,14.6 C4.7,14.6 4.5,14.7 4.2,15 C3.9,15.2 3.4,15.5 2.7,15.5 C4.3,17.4 6,18.4 8.1,19.2 C10.2,18.4 11.9,17.5 13.5,15.5 C12.8,15.5 12.3,15.2 12,15 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M1.6,11.9 C1.9,12.1 2.1,12.3 2.7,12.3 C3.2,12.3 3.5,12.2 3.8,11.9 C4.2,11.7 4.6,11.4 5.5,11.4 C6.4,11.4 6.8,11.7 7.2,11.9 C7.5,12.1 7.8,12.3 8.3,12.3 C8.8,12.3 9.1,12.2 9.4,11.9 C9.8,11.7 10.2,11.4 11.1,11.4 C11.9,11.4 12.4,11.7 12.8,11.9 C13.1,12.1 13.4,12.3 13.9,12.3 C14.4,12.3 14.7,12.2 15,11.9 C15.3,11.7 15.7,11.5 16.3,11.4 C16.5,11 16.6,10.5 16.8,9.9 L12.9,3.4 L11.4,6.3 L8.5,0.4 L5.6,6.3 L4.1,3.4 L0.2,9.9 C0.3,10.5 0.5,10.9 0.7,11.4 C0.9,11.5 1.3,11.7 1.6,11.9 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M15.3,12.8 C14.9,13 14.5,13.3 13.6,13.3 C12.8,13.3 12.3,13 11.9,12.8 C11.6,12.6 11.3,12.4 10.8,12.4 C10.3,12.4 10,12.5 9.7,12.8 C9.3,13 8.9,13.3 8,13.3 C7.2,13.3 6.7,13 6.3,12.8 C6,12.6 5.7,12.4 5.2,12.4 C4.7,12.4 4.4,12.5 4.1,12.8 C3.7,13 3.3,13.3 2.4,13.3 C1.6,13.3 1.1,13 0.7,12.8 L0.7,12.8 C1,13.3 1.3,13.8 1.6,14.2 C1.8,14.3 2,14.4 2.4,14.4 C2.9,14.4 3.2,14.3 3.5,14 C3.9,13.8 4.3,13.5 5.2,13.5 C6.1,13.5 6.5,13.8 6.9,14 C7.2,14.2 7.5,14.4 8,14.4 C8.5,14.4 8.8,14.3 9.1,14 C9.5,13.8 9.9,13.5 10.8,13.5 C11.6,13.5 12.1,13.8 12.5,14 C12.8,14.2 13.1,14.4 13.6,14.4 C14,14.4 14.2,14.3 14.4,14.2 C14.8,13.8 15.1,13.3 15.3,12.8 L15.3,12.8 Z",
        id: "Path"
      })), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M49.8,20 C49.8,20.5 49.8,20.9 49.8,21.4 C49.6,26.7 48.8,38.2 47.1,41.6 C44.6,46.7 42.2,48.3 38.1,49.9 C34,48.4 31.7,46.7 29.1,41.6 C27.4,38.1 26.6,26.4 26.4,21.4 C26.4,20.9 26.4,20.4 26.4,20 C25.9,20.2 25.4,20.4 24.9,20.6 C24.9,21.6 25.2,28.3 26,34.3 C26.4,37.6 27,40.6 27.8,42.3 C30.7,48.1 33.7,49.8 38.1,51.4 C42.5,49.8 45.4,48.1 48.4,42.3 C49.2,40.7 49.8,37.6 50.2,34.3 C51,28.4 51.2,21.7 51.3,20.6 C50.9,20.4 50.3,20.2 49.8,20 Z",
        id: "Path",
        fill: "#FF5252"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        fill: "#FFE500",
        points: "34 20.5 34.4 21.2 35.1 21.2 34.8 21.8 35.1 22.5 34.4 22.5 34 23.2 33.6 22.5 32.8 22.5 33.2 21.8 32.8 21.2 33.6 21.2"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        fill: "#FFE500",
        points: "42.4 20.5 42.8 21.2 43.6 21.2 43.2 21.8 43.6 22.5 42.8 22.5 42.4 23.2 42 22.5 41.3 22.5 41.7 21.8 41.3 21.2 42.1 21.2"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        fill: "#FFE500",
        points: "38.2 24.6 38.5 25.3 39.3 25.3 38.9 25.9 39.3 26.6 38.5 26.6 38.2 27.3 37.8 26.6 37 26.6 37.4 25.9 37 25.3 37.8 25.3"
      }))));
    }
  }]);
}(_react["default"].Component), _FlagSlIcon.defaultProps = {
  width: '20px'
}, _FlagSlIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagSlIcon);